interface ThumbsDownIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function ThumbsDownIcon({ 
  size = 24, 
  color = '#1B2831',
  className = '' 
}: ThumbsDownIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M19 2H6.27001C5.5682 2.00023 4.88868 2.24651 4.34969 2.69598C3.81069 3.14544 3.44633 3.76965 3.32001 4.46L2.05001 11.46C1.97088 11.8924 1.98775 12.337 2.09944 12.7622C2.21113 13.1874 2.41491 13.5828 2.69634 13.9206C2.97778 14.2583 3.33 14.53 3.72809 14.7166C4.12617 14.9031 4.56039 14.9999 5.00001 15H9.56001L9.00001 16.43C8.76707 17.0561 8.6895 17.7294 8.77394 18.3921C8.85838 19.0548 9.10232 19.6871 9.48482 20.2348C9.86732 20.7825 10.377 21.2292 10.9701 21.5367C11.5632 21.8441 12.222 22.0031 12.89 22C13.0824 21.9996 13.2705 21.9437 13.4319 21.8391C13.5933 21.7344 13.7211 21.5854 13.8 21.41L16.65 15H19C19.7957 15 20.5587 14.6839 21.1213 14.1213C21.6839 13.5587 22 12.7956 22 12V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7957 2 19 2ZM15 13.79L12.28 19.91C12.0017 19.8258 11.7436 19.6855 11.5215 19.4978C11.2995 19.31 11.1183 19.0788 10.989 18.8183C10.8597 18.5579 10.7851 18.2737 10.7698 17.9834C10.7545 17.693 10.7988 17.4026 10.9 17.13L11.43 15.7C11.5429 15.3977 11.5811 15.0727 11.5411 14.7525C11.5012 14.4323 11.3844 14.1265 11.2007 13.8613C11.017 13.596 10.7718 13.3791 10.4861 13.2292C10.2004 13.0792 9.88267 13.0006 9.56001 13H5.00001C4.8531 13.0002 4.70794 12.9681 4.57485 12.9059C4.44177 12.8437 4.32403 12.7529 4.23001 12.64C4.13367 12.5287 4.06311 12.3975 4.02335 12.2557C3.98359 12.114 3.97562 11.9652 4.00001 11.82L5.27001 4.82C5.3126 4.58704 5.43649 4.37676 5.61962 4.2266C5.80274 4.07644 6.03322 3.99614 6.27001 4H15V13.79ZM20 12C20 12.2652 19.8947 12.5196 19.7071 12.7071C19.5196 12.8946 19.2652 13 19 13H17V4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8947 4.48043 20 4.73478 20 5V12Z" fill={color} />
    </svg>
  );
}
